import moment from 'moment'

export const adjustDate = date => { console.log(date); return date
    ? moment(date).toISOString().replace(".000Z","Z")
    : null
}

export const justDate = date => {
    return moment(date).format('MM-DD-YYYY')
}